import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=16403e50"
import script from "./OrdersView.vue?vue&type=script&lang=ts"
export * from "./OrdersView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports